import React from 'react';
import newcoreAppIcon from '@/assets/newcore-app-icon.svg';
import { Onboarding } from '@/features/onboarding/components/primitives';

interface WelcomeStepProps {
  userName?: string;
  onGetStarted: () => void;
  isLoading?: boolean;
}

/**
 * Welcome step - First step of the onboarding wizard
 * Shows NewCore logo, personalized greeting, and Get Started button
 */
export const WelcomeStep: React.FC<WelcomeStepProps> = ({
  userName,
  onGetStarted,
  isLoading = false,
}) => {
  const welcomeTitle = userName ? `Welcome, ${userName}!` : 'Welcome!';

  return (
    <div className='flex flex-col items-center text-center space-y-6 py-2'>
      {/* Logo */}
      <img
        src={newcoreAppIcon}
        alt='NewCore'
        className='h-20 w-20 object-contain'
      />

      {/* Welcome Message */}
      <Onboarding.Header>
        <Onboarding.Title>{welcomeTitle}</Onboarding.Title>
        <Onboarding.Description>
          Core Identity Platform is the front door to your organization&apos;s
          digital workspace.
          <br />
          Let&apos;s secure your access in just a few minutes.
        </Onboarding.Description>
      </Onboarding.Header>

      {/* Get Started Button */}
      <Onboarding.NextButton
        onClick={onGetStarted}
        loading={isLoading}
        className='w-full max-w-xs mt-2'
      >
        Get Started
      </Onboarding.NextButton>
    </div>
  );
};
